import axios from "axios";

export const ResendOtpApi = (payload) => {
  const prodUrl = process.env.REACT_APP_BASE_URL;

  return axios
    .post(prodUrl + "user-service/api/v1/users/resend-otp/", {
      email_or_phone: payload,
    })
    .then(function (response) {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
